<template>
  <b-card no-body>
    <b-card-header>
      <b-input-group class="w-50">
        <b-form-input
          v-model="search"
          placeholder="Anahtar veya başlık ara..."
          @keydown.enter="searchData"
        />
        <b-input-group-append>
          <b-button
            variant="primary"
            @click="searchData"
          >
            <FeatherIcon icon="SearchIcon" />
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <b-button
        variant="primary"
        to="/app/site-blocks/add"
      >
        <FeatherIcon icon="PlusIcon" />
        Blok Ekle
      </b-button>
    </b-card-header>
    <b-table
      responsive="sm"
      :fields="fields"
      :items="dataList"
      striped
    >
      <template #cell(block_key)="data">
        <code>{{ data.item.block_key }}</code>
      </template>
      <template #cell(title)="data">
        <div>{{ data.item.title || '-' }}</div>
        <div
          v-if="data.item.eyebrow"
          class="text-muted font-small-2"
        >
          {{ data.item.eyebrow }}
        </div>
      </template>
      <template #cell(media)="data">
        <FeatherIcon
          v-if="data.item.image"
          icon="ImageIcon"
          class="text-success mr-50"
        />
        <FeatherIcon
          v-if="data.item.video"
          icon="FilmIcon"
          class="text-success"
        />
      </template>
      <template #cell(control)="data">
        <div class="text-right">
          <list-dropdown-buttons
            :primary-action="'/app/site-blocks/edit/' + data.item.id"
            primary-text="Güncelle"
            :data-id="data.item.id"
            :delete-action="removeData"
          />
        </div>
      </template>
    </b-table>
    <b-card-footer>
      <b-pagination
        v-model="currentPage"
        :total-rows="dataCounts"
        :per-page="perPage"
        first-number
        last-number
        prev-class="prev-item"
        next-class="next-item"
      >
        <template #prev-text>
          <feather-icon
            icon="ChevronLeftIcon"
            size="18"
          />
        </template>
        <template #next-text>
          <feather-icon
            icon="ChevronRightIcon"
            size="18"
          />
        </template>
      </b-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import {
  BCard, BCardHeader, BCardFooter, BTable, BPagination, BButton, BFormInput, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'
import ListDropdownButtons from '@/layouts/components/common/ListDropdownButtons.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'SiteBlocksIndex',
  components: {
    BCard,
    BCardHeader,
    BCardFooter,
    BTable,
    BPagination,
    BButton,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    ListDropdownButtons,
  },
  data() {
    return {
      search: null,
      currentPage: 1,
      perPage: 50,
      fields: [
        {
          key: 'block_key',
          label: 'ANAHTAR',
          thStyle: { width: '220px' },
        },
        {
          key: 'title',
          label: 'BAŞLIK',
        },
        {
          key: 'media',
          label: 'MEDYA',
          thStyle: { width: '100px' },
        },
        {
          key: 'control',
          label: '',
          thStyle: { width: '200px' },
        },
      ],
      dataQuery: {
        limit: 50,
        start: 0,
        search: null,
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['siteBlocks/dataList']
    },
    dataCounts() {
      return this.$store.getters['siteBlocks/dataCounts']
    },
    saveData() {
      return this.$store.getters['siteBlocks/dataSaveStatus']
    },
  },
  watch: {
    currentPage(val) {
      this.dataQuery.start = (val - 1) * this.perPage
      this.getDataList()
    },
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
      this.getDataList()
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    searchData() {
      this.dataQuery.search = this.search
      this.dataQuery.start = 0
      this.currentPage = 1
      this.getDataList()
    },
    getDataList() {
      this.$store.dispatch('siteBlocks/getDataList', this.dataQuery)
    },
    removeData(id) {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: 'Bu blok sitede kullanılıyorsa ilgili alan boş görünür.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('siteBlocks/removeData', id)
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
